export default {"src":"/_next/static/media/arrow-down-bold-black.41740ab0.svg","height":24,"width":24};